import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class ParamsHelperService {
    private _queryParams: any = {};

    constructor(
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    /**
     * Get all query parameters as an object.
     */
    private get queryParams(): Params {
        return this._queryParams;
    }

    /**
     * Get a specific query parameter by name.
     */
    public getQueryParam(name: string): string | null {
        return this._queryParams[name];
    }

    /**
     * Get all query parameters as an object.
     */
    public getQueryParams(): any | null {
        return this._queryParams;
    }

    /**
     * Set query parameters.
     */
    public setQueryParams(params: any): void {
        if (params == null) params = {};
        this._queryParams = Object.assign(this._queryParams, params);
    }

    /**
     * Update a specific query parameter.
     */
    public updateQueryParam(name: string, value: string): void {
        const queryParams = { ...this._queryParams, [name]: value };
        this.setQueryParams(queryParams);
    }

    /**
     * Remove a specific query parameter.
     */
    public removeQueryParam(name: string): void {
        const queryParams = { ...this._queryParams };
        delete queryParams[name];
        this.setQueryParams(queryParams);
    }
}
